export default __webpack_public_path__ + "static/media/twitter.b65072b5.svg";